import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pe-3",
  style: {"background":"#f5f5f5","height":"100%","display":"flex","align-items":"center"}
}
const _hoisted_2 = { class: "caption text-grey-900" }

import { computed } from 'vue'

  // Components
  import PageSection from '@/components/UI/PageSection.vue'
  import Input from '@/components/UI/Input.vue'

  // Icons
  import LockIcon from '@/assets/LockIcon.vue'

  // Types
  import { FormProps } from './EditInfoForm.types'

  // Translations
  import { useI18n } from 'vue-i18n'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'InfoFields',
  props: {
    userInfo: {},
    formValues: {},
    updateFN: { type: Function },
    invalidFields: {},
    loading: { type: Boolean },
    editable: { type: Boolean }
  },
  setup(__props: any) {

  // Vue
  const { t } = useI18n()

  // Props
  

  // Computed
  const readonlyStyles = computed(() => ({
    border: 'none',
    backgroundColor: '#f5f5f5',
    cursor: 'not-allowed',
  }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageSection, {
    title: _unref(t)('profile.editInfoForm.infoTitle')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(Input, {
          id: "first-name",
          label: _unref(t)('profile.editInfoForm.firstName'),
          placeholder: _unref(t)('profile.editInfoForm.firstName'),
          value: _ctx.formValues.first_name,
          onInput: _cache[0] || (_cache[0] = (value) => _ctx.updateFN('first_name', value)),
          error: _unref(t)('errorMessages.fieldMandatory'),
          "show-error": _ctx.invalidFields.has('first_name'),
          readOnly: !_ctx.editable || _ctx.loading,
          "input-styles": !_ctx.editable ? readonlyStyles.value : {}
        }, null, 8, ["label", "placeholder", "value", "error", "show-error", "readOnly", "input-styles"]),
        _createVNode(Input, {
          id: "last-name",
          label: _unref(t)('profile.editInfoForm.lastName'),
          placeholder: _unref(t)('profile.editInfoForm.lastName'),
          value: _ctx.formValues.last_name,
          onInput: _cache[1] || (_cache[1] = (value) => _ctx.updateFN('last_name', value)),
          error: _unref(t)('errorMessages.fieldMandatory'),
          "show-error": _ctx.invalidFields.has('last_name'),
          readOnly: !_ctx.editable || _ctx.loading,
          "input-styles": !_ctx.editable ? readonlyStyles.value : {}
        }, null, 8, ["label", "placeholder", "value", "error", "show-error", "readOnly", "input-styles"]),
        _createVNode(Input, {
          id: "email",
          label: _unref(t)('profile.editInfoForm.email'),
          placeholder: _unref(t)('profile.editInfoForm.email'),
          error: _unref(t)('errorMessages.fieldMandatory'),
          readOnly: "",
          "input-styles": readonlyStyles.value,
          value: _ctx.userInfo.email
        }, {
          after: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              _createVNode(LockIcon)
            ])
          ]),
          _: 1
        }, 8, ["label", "placeholder", "error", "input-styles", "value"]),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('profile.editInfoForm.emailChangeInfo')), 1)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})